<template>
  <div class="stage-wrapper">
    <div class="flex align-center justify-between stage-title margin-bottom-sm">
      <h3>{{ stageTitle }}</h3>
    </div>
    <div class="edit-box">
      <el-form :model="stageForm" :rules="rules" :label-position="'top'" ref="stageForm" label-width="100px"
               class="demo-stageForm">
        <el-form-item label="打分细则" prop="content">
          <VueUditorWrap v-model="stageForm.content" :config="myConfig"></VueUditorWrap>
        </el-form-item>
        <el-form-item label="满分" prop="score">
          <el-input type="number" v-model.number="stageForm.score" aria-placeholder="请输入">
            <template slot="append">分</template>
          </el-input>
        </el-form-item>

        <el-form-item label="打分项" prop="scoreList" v-if="stageForm.score">
          <el-checkbox-group v-model="stageForm.scoreList">
            <el-checkbox :label="item.score" name="type" v-for="item in scoreList" :key="item.score">{{ item.name }}
            </el-checkbox>
          </el-checkbox-group>
        </el-form-item>
        <el-form-item label="重点项" prop="keynote">
          <el-radio-group v-model="stageForm.keynote">
            <el-radio :label="0">否</el-radio>
            <el-radio :label="1">是</el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item>
          <div class="flex align-center justify-center">
            <el-button type="primary" @click="submitForm('stageForm')" style="width: 200px">保存</el-button>
          </div>

        </el-form-item>
      </el-form>


    </div>
  </div>
</template>

<script>
import VueUditorWrap from 'vue-ueditor-wrap'
import {bdEditConfig} from "@/utils";
import {getAffiliatedContent, saveAffiliatedContent} from "@/api/admin";

export default {
  name: "stageInfoModular",
  data() {
    return {
      myConfig: bdEditConfig(),
      scoreList: [],
      stageForm: {
        content: '',
        score: '',
        scoreList: [],
        keynote: 0,
      },
      rules: {
        content: [{required: true, message: '请输入打分细则', trigger: 'blur'}],
        score: [{type: 'number',required: true,min:1, message: '请输入满分', trigger: 'blur'}],
        scoreList: [{type: 'array', required: true, message: '至少选择1个打分项', trigger: 'change'}],
        keynote: [{required: true, message: '请选择是否为重点项', trigger: 'change'}],
      }

    }
  },
  props: {
    stageTitle: {
      type: String,
    },
    infoId: {
      type: Number,
      default: () => {
        return 0
      }
    },
    parentId: {
      type: Number,
      default: () => {
        return 0
      }
    },
  },
  created() {
    this.getDetail()
  },
  components: {VueUditorWrap},
  methods: {
    //  获取详情
    async getDetail(){
      const res = await getAffiliatedContent(this.parentId)
      this.stageForm = {
        content: res.data.content,
        score: res.data.total_points?Number(res.data.total_points):'',
        scoreList: [],
        keynote: res.data.is_focus,
      }
      this.$nextTick(()=>{
        this.stageForm.scoreList = res.data.json.split(',').map(Number)
      })
    },
      //   保存
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.submitData()
        }
      });
    },
    async submitData() {
      let _state = await saveAffiliatedContent(
        this.infoId, this.parentId,
        this.stageForm.content,
        this.stageForm.score,
        this.stageForm.scoreList.join(','),
        this.stageForm.keynote,
      );
      if (_state.status === 200) this.$message.success(_state.msg);
    }
  },
  filters: {},
  watch: {
    parentId(){
      this.getDetail()
    },
    'stageForm.score'() {
      if (this.stageForm.score) {
        this.scoreList = []
        this.stageForm.scoreList = []
        for (let i = this.stageForm.score; i >= 0; i--) {
          this.stageForm.scoreList.push(i)
          this.scoreList.push({
            score: i,
            name: i + '分'
          })
        }
        this.stageForm.scoreList.push(-1)
        this.scoreList.push({
          score: -1,
          name: '无涉指标'
        })
      }
    }
  },
}
</script>

<style scoped lang="scss">
.stage-wrapper {
  width: calc((100vw - 350px) / 3);
  min-height: calc(100vh - 250px);
  background-color: #f5f5f5;
  border-radius: 10px;
  padding: 12px;

  .edit-box {
    background: #fff;
    padding: 10px;
    border-radius: 10px;
  }

}
</style>
